import React from 'react';

import LabelCDS from '@sharedCR/coreDesignSystem/LabelCDS';
import { LabelSize } from '@sharedCR/coreDesignSystem/LabelCDS/LabelCDS.constants';
import PropTypes from 'prop-types';

import { CicReasonStatusEnum } from 'constants/status';

import { CicStatusConfig } from './CicReasonStatus.constants';

const CicReasonStatus = ({ status }) => {
  const config = CicStatusConfig[status];

  if (!config) {
    return null;
  }

  return (
    <LabelCDS
      size={LabelSize.S}
      title={status === CicReasonStatusEnum.SAVED ? CicReasonStatusEnum.PENDING : status}
      variant={config.variant}
    />
  );
};

CicReasonStatus.propTypes = {
  status: PropTypes.oneOf(Object.values(CicReasonStatusEnum)).isRequired,
};

export default CicReasonStatus;
